export class InstallationBranchMoving {
    id: number;
    installationName: string;
    destinationBranchName: string;
    movingDateTime: Date;
    username: string;

    constructor() {}

    public parse(obj: any) {
        if (obj.Id != null) this.id = obj.Id;
        if (obj.InstallationName != null) this.installationName = obj.InstallationName;
        if (obj.DestinationBranchName != null) this.destinationBranchName = obj.DestinationBranchName;
        if (obj.MovingDateTime != null) this.movingDateTime = obj.MovingDateTime;
        if (obj.Username != null) this.username = obj.Username;
    }
}
